import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { siteTitle } from '../../utils/constants'

const defaults = {
  title: siteTitle,
  description:
    'Find the best prices on running shoes from top sneaker brands: Nike, Brooks, Asics, Saucony, Mizuno, New Balance, Adidas, Hoka One One and more!',
  imageUrl: 'https://file-hmxexcngjj.now.sh/',
}

const SeoHead = ({ title, ogDescription, ogTitle, ogImageUrl, ogUrl }) => (
  <Helmet>
    <html lang="en" />
    <title>{title || defaults.title}</title>
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:site" content="@shoe_kicker" />
    <meta name="twitter:image" content={ogImageUrl || defaults.imageUrl} />
    <meta
      name="description"
      content={ogDescription || defaults.description}
      key="description"
    />
    <meta property=" title" content={title || defaults.title} key="ogtitle" />
    <meta property="og:type" content="website" key="ogtype" />
    <meta
      property="og:image"
      content={ogImageUrl || defaults.imageUrl}
      key="ogimage"
    />
    {ogUrl && <meta property="og:url" content={ogUrl} />}
  </Helmet>
)

SeoHead.propTypes = {
  title: PropTypes.string,
  ogDescription: PropTypes.string,
  ogTitle: PropTypes.string,
  ogImageUrl: PropTypes.string,
  ogUrl: PropTypes.string,
}

export default SeoHead
